import axios from 'axios';

export default function resendEmail({ id }) {
  return new Promise((resolve, reject) => axios
    .post('/notification/system-admin/api/v1/email/retrySendEmail',
      { id })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
